/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, {useRef } from 'react'

const Tooltip = ({ children, wrapperClassName = "", className="", text = '', delay = 500, color = 'var(--accent-color)', textClassName="darkPrimaryColor dark:darkTooltipColor" }) => {
    const tooltipRef = useRef();

    return (
        <span ref={tooltipRef} className={wrapperClassName}>
            <span className='tooltip-hover after:hover:light-bg-radial-gradient5 dark:after:hover:dark-bg-radial-gradient5'>{children}</span>
            <span className={`${className} tooltip-text light-bg-radial-gradient5 dark:dark-bg-radial-gradient5`}><span className={textClassName} dangerouslySetInnerHTML={{__html: text}}></span></span>
        </span>
    )
}

export default Tooltip